import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg)" }}>
      <div
        className="h-10 w-10 rounded-full border-2 animate-spin"
        style={{ borderColor: "var(--border)", borderTopColor: "var(--brand)" }}
      />
    </div>
  );
}

// Requires a business to be selected; otherwise sends to the launcher.
export function RequireBusiness({ children }) {
  const { selectedBusinessId, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!selectedBusinessId) return <Navigate to="/" replace />;
  return children;
}

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  return children;
}

export function RequireBaker({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/sign-in" replace />;
  if (user.role !== "baker") return <Navigate to="/shop" replace />;
  return children;
}
